export default {
  methods: {
    getPreviousLoanRecord (id, status) {
      var pageUrl = ''
      pageUrl += 'memberloanplan?all=all'
      if (id) {
        pageUrl += `&member_id=${id}`
      }
      if (status) {
        if (status === 'processingAndPending') {
          pageUrl += `&multiplestatus[]=pending`
          pageUrl += `&multiplestatus[]=processing`
        } else {
          pageUrl += `&status=${status}`
        }
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.memberloanplans = data.data
        }).catch(function (error) { console.log(error) })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/PreviousLoanRecord.js